<template>
<div>
  <v-tabs class="pa-0 ma-0" v-model="tab" color="transparent" slider-color="accent" centered>
    <v-tab ripple><b>Edit</b></v-tab>
    <v-tab ripple><b>Preview</b></v-tab>
    <v-tab-item>
      <r-edit-linked></r-edit-linked>
    </v-tab-item>
    <v-tab-item>
      <r-linked-preview></r-linked-preview>
    </v-tab-item>
  </v-tabs>
</div>
</template>

<script>
import EditLinked from './EditLinked.vue'
import LinkedPreview from './LinkedPreview.vue'
export default {
  components: {
    rEditLinked: EditLinked,
    rLinkedPreview: LinkedPreview
  },
  data: () => ({
    tab: null
  })
}
</script>



// WEBPACK FOOTER //
// src/components/content/LinkedTask.vue